/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC, Fragment, MouseEvent, useEffect, useMemo, useState } from 'react';
import ReactGA from 'react-ga4';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AccountCircle,
  ArrowDropDown as ArrowDropDownIcon,
  KeyboardArrowDown,
} from '@mui/icons-material';
import { Divider, IconButton, Menu, MenuItem, Toolbar } from '@mui/material';
import moment from 'moment';

import Logo from '@/assets/icons/generals/logo.svg';
import logoutIcon from '@/assets/icons/generals/logoutIcon.svg';
import menuHamburguer from '@/assets/icons/generals/menuHamburguerwhite.svg';

import { getStringFormatted } from '@/utils/Formatter';

import { useUser } from '@/context/UserContext';
import useSelectRole from '@/context/useSelectRole';
import { useViewMode } from '@/context/ViewMode/ViewMode';

import { useRequestSupportModal } from '@/hooks/useRequestModal';

import RequestHostOpsModal from '@/components/RequestHostOpsModal/RequestHostOpsModal';

import ReportBugButton from './ReportBugButton';
import {
  ColoredBar,
  ContainerImages,
  LogoImage,
  MenuMobile,
  NavLink,
  Profile,
  TextContainer,
  Username,
  Wrapper,
  WrapperNav,
} from './styles';

type Options = {
  url: string;
  name: string;
  children?: Options[];
};

interface Props {
  color: string;
  className?: string;
  useOnlyArrow: boolean;
  hideName?: boolean;
  useNewDesign?: boolean;
}

const options: Options[] = [
  {
    url: '/',
    name: 'Calendario',
  },
  {
    url: '/proprietario',
    name: 'Proprietário',
  },
  {
    url: '/propriedades',
    name: 'Propriedades',
  },
  {
    url: '/controle',
    name: 'Controle',
  },
];

const hostOptions: Options[] = [
  {
    url: '/',
    name: 'Calendario',
  },
  {
    url: '/controle',
    name: 'Controle',
  },
];

const ownerOptions: Options[] = [
  {
    url: '/proprietario',
    name: 'Proprietário',
  },
];
const WIDTH_MOBILE = 900;

const AccountIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M12.5586 2.25C10.6302 2.25 8.74517 2.82183 7.14179 3.89317C5.53841 4.96451 4.28873 6.48726 3.55077 8.26884C2.81282 10.0504 2.61974 12.0108 2.99594 13.9021C3.37215 15.7934 4.30075 17.5307 5.66431 18.8943C7.02787 20.2579 8.76515 21.1865 10.6565 21.5627C12.5478 21.9389 14.5082 21.7458 16.2898 21.0078C18.0713 20.2699 19.5941 19.0202 20.6654 17.4168C21.7368 15.8134 22.3086 13.9284 22.3086 12C22.3059 9.41498 21.2778 6.93661 19.4499 5.10872C17.622 3.28084 15.1436 2.25273 12.5586 2.25ZM7.5036 18.5156C8.04616 17.6671 8.7936 16.9688 9.67702 16.4851C10.5604 16.0013 11.5514 15.7478 12.5586 15.7478C13.5658 15.7478 14.5568 16.0013 15.4402 16.4851C16.3236 16.9688 17.071 17.6671 17.6136 18.5156C16.1683 19.6397 14.3896 20.2499 12.5586 20.2499C10.7276 20.2499 8.94891 19.6397 7.5036 18.5156ZM9.5586 11.25C9.5586 10.6567 9.73455 10.0766 10.0642 9.58329C10.3938 9.08994 10.8624 8.70542 11.4105 8.47836C11.9587 8.2513 12.5619 8.19189 13.1439 8.30764C13.7258 8.4234 14.2604 8.70912 14.6799 9.12868C15.0995 9.54824 15.3852 10.0828 15.501 10.6647C15.6167 11.2467 15.5573 11.8499 15.3302 12.3981C15.1032 12.9462 14.7187 13.4148 14.2253 13.7444C13.732 14.0741 13.1519 14.25 12.5586 14.25C11.7629 14.25 10.9999 13.9339 10.4373 13.3713C9.87467 12.8087 9.5586 12.0456 9.5586 11.25ZM18.7236 17.4759C17.8871 16.2638 16.711 15.3261 15.343 14.7806C16.0778 14.2019 16.614 13.4085 16.877 12.5108C17.1401 11.6132 17.1168 10.6559 16.8105 9.77207C16.5043 8.88825 15.9302 8.12183 15.1682 7.5794C14.4061 7.03696 13.494 6.74548 12.5586 6.74548C11.6232 6.74548 10.7111 7.03696 9.94903 7.5794C9.18699 8.12183 8.61292 8.88825 8.30665 9.77207C8.00038 10.6559 7.97714 11.6132 8.24016 12.5108C8.50319 13.4085 9.0394 14.2019 9.77422 14.7806C8.40624 15.3261 7.23006 16.2638 6.3936 17.4759C5.33663 16.2873 4.64579 14.8185 4.40427 13.2464C4.16274 11.6743 4.38083 10.0658 5.03227 8.61478C5.68371 7.16372 6.74073 5.93192 8.07604 5.06769C9.41135 4.20346 10.968 3.74367 12.5586 3.74367C14.1492 3.74367 15.7058 4.20346 17.0412 5.06769C18.3765 5.93192 19.4335 7.16372 20.0849 8.61478C20.7364 10.0658 20.9545 11.6743 20.7129 13.2464C20.4714 14.8185 19.7806 16.2873 18.7236 17.4759Z"
      fill="white"
    />
  </svg>
);

export const ProfileLogout: FC<Props> = ({
  color,
  className,
  useOnlyArrow,
  hideName,
  useNewDesign,
}) => {
  const { viewModeInfo } = useViewMode();

  const { routesArray, resolveNavigateRouteWithPrefix } = useSelectRole();
  const routes = useMemo(
    () => routesArray?.filter((route) => route?.name !== 'Host'),
    [routesArray],
  );

  const [anchorProfile, setAnchorProfile] = useState<Element | null>(null);
  const { userInformation, logout } = useUser();
  const roles = viewModeInfo?.roles || userInformation?.roles || [];
  const { handleOpenReportBugModal: openModal } = useRequestSupportModal();
  const [isOpenedRequestHostOpsModal, setIsOpenedRequestHostOpsModal] = useState(false);
  const isHostOps = userInformation?.host?.is_host_ops || false;

  const navigate = useNavigate();
  const nick = userInformation?.nickname || '';
  const nickname = getStringFormatted(nick, 18, 15);

  const [showUsername, setShowUsername] = useState<boolean>(false);

  const { innerWidth: width } = window;
  const mobile = width < WIDTH_MOBILE;
  const { id } = useParams();

  useEffect(() => {
    const paths = ['/proprietario', `/proprietario/${id}`];
    if (paths.includes(window.location.pathname) && !mobile) {
      setShowUsername(true);
    }
  }, []);

  const handleLogout = () => {
    const start = localStorage.getItem('startUse');
    const duration = moment.duration(moment().diff(moment(start)));
    const seconds = duration.asSeconds();
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds / 60) % 60);
    const secs = Math.floor(seconds % 60);
    ReactGA.event(localStorage.getItem('userDetail') || 'Indefinido', {
      category: localStorage.getItem('userDetail') || 'Indefinido',
      action: `Tempo de acesso ${hours}:${mins}:${secs}`,
    });
    logout();
    navigate('/login');
  };

  const handleProfile = (event: MouseEvent) => {
    setAnchorProfile(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorProfile(null);
  };

  const handleNavigateToMyData = () => {
    handleClose();
    navigate('/meusdados');
  };

  const handleNavigateToMyDataHost = () => {
    handleClose();
    navigate('/minhasinformacoes');
  };

  const handleOpenRequesHostOpsModal = () => {
    handleClose();
    setIsOpenedRequestHostOpsModal(true);
  };

  const handleCloseRequesHostOpsModal = () => {
    handleClose();
    setIsOpenedRequestHostOpsModal(false);
  };

  const handleOpenReportBugModal = () => {
    handleClose();
    openModal();
  };

  const handleOpenUserManual = () => {
    handleClose();
    window.open(
      'https://thread-wave-20a.notion.site/Manual-de-Usu-rio-Propriet-rios-ef5ee1f7de63439a950ffbeacd5b71f0',
      '_blank',
    );
  };

  return (
    <Profile className={className}>
      {!hideName && showUsername && <Username>{nickname}</Username>}
      {useOnlyArrow ? (
        <IconButton
          data-cy="profile-icon"
          aria-label="Profile of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleProfile}
          color="inherit"
          style={{ color }}
        >
          <KeyboardArrowDown />
        </IconButton>
      ) : (
        <IconButton
          data-cy="profile-icon"
          aria-label="Profile of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleProfile}
          color="inherit"
          style={{ color }}
        >
          {useNewDesign ? <AccountIconSVG /> : <AccountCircle />}
          <ArrowDropDownIcon />
        </IconButton>
      )}
      <Menu
        className="account-menu"
        anchorEl={anchorProfile}
        keepMounted
        open={Boolean(anchorProfile)}
        onClose={handleClose}
        style={{ marginTop: 20 }}
        disableScrollLock
      >
        <MenuItem disabled>Principal</MenuItem>
        {(roles.includes('Owner') || roles.includes('Admin')) && (
          <MenuItem key="meus dados" onClick={handleNavigateToMyData}>
            Meus dados
          </MenuItem>
        )}
        {(roles.includes('Host') || roles.includes('Admin')) && (
          <MenuItem key="minhas informações" onClick={handleNavigateToMyDataHost}>
            Minhas informações
          </MenuItem>
        )}

        {(roles.includes('Host') || roles.includes('Admin')) && isHostOps === false && (
          <MenuItem key="minhas informações" onClick={handleOpenRequesHostOpsModal}>
            Solicitar criação
            <br />
            de subconta
          </MenuItem>
        )}

        <Divider />
        <MenuItem disabled>Navegação</MenuItem>
        {routes?.map((route) => (
          <MenuItem
            key="rotas de navegacao"
            onClick={() => {
              handleClose();
              navigate(route?.link || '');
            }}
          >
            {resolveNavigateRouteWithPrefix(route)}
          </MenuItem>
        ))}
        <Divider />
        <MenuItem key="manual do usuário" onClick={() => handleOpenUserManual()}>
          Manual do usuário
        </MenuItem>
        <Divider />
        {(roles.includes('Host') || roles.includes('Owner') || roles.includes('Admin')) &&
          isHostOps === false && (
            <MenuItem key="bug report" onClick={handleOpenReportBugModal}>
              <ReportBugButton />
            </MenuItem>
          )}
        <Divider />
        <MenuItem data-cy="btn-logout" key="submenu-logout" onClick={handleLogout}>
          <img src={logoutIcon} alt="logout icone" style={{ height: 17, paddingRight: 10 }} />
          Sair
        </MenuItem>
      </Menu>
      {isOpenedRequestHostOpsModal && (
        <RequestHostOpsModal handleCloseModal={handleCloseRequesHostOpsModal} />
      )}
    </Profile>
  );
};

ProfileLogout.defaultProps = {
  className: '',
  hideName: false,
};

const Header = () => {
  const { userInformation } = useUser();
  const roles = userInformation?.roles || [];
  const [anchor, setAnchor] = useState<Element | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [mobile, setMobile] = useState<boolean>(false);

  function useWindowSize() {
    const { innerWidth: width } = window;
    if (width < WIDTH_MOBILE) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }
  useEffect(() => {
    window.addEventListener('resize', useWindowSize);
  }, [mobile]);

  useEffect(() => {
    useWindowSize();
  }, []);

  const handleClick = (event: MouseEvent) => {
    setAnchor(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchor(null);
  };

  if (roles.includes('Host')) {
    return (
      <ColoredBar>
        <Toolbar variant="dense">
          <LogoImage src={Logo} alt="*" />
          <TextContainer>
            {hostOptions.map((data, indexMenu) => (
              <Fragment key={`menu-${indexMenu.toString()}`}>
                {!data.children && (
                  <NavLink
                    to={data.url}
                    className={({ isActive: active }) => `nav-link${active ? 'active' : ''}`}
                  >
                    {data.name}
                  </NavLink>
                )}
                {data.children?.length && (
                  <>
                    <NavLink
                      to={data.url}
                      onMouseOver={handleClick}
                      className={({ isActive: active }) => `nav-link${active ? 'active' : ''}`}
                    >
                      {data.name}
                    </NavLink>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchor}
                      keepMounted
                      open={Boolean(anchor)}
                      onClose={handleClose}
                    >
                      {data.children.map((submenu, index) => (
                        <MenuItem key={`submenu-${index.toString()}`} onClick={handleClose}>
                          {submenu.name}
                        </MenuItem>
                      ))}
                    </Menu>
                    <ArrowDropDownIcon />
                  </>
                )}
              </Fragment>
            ))}
          </TextContainer>
          <ProfileLogout useOnlyArrow={false} color="white" />
        </Toolbar>
      </ColoredBar>
    );
  }

  if (roles.includes('Owner')) {
    return (
      <ColoredBar>
        <Toolbar variant="dense">
          <LogoImage src={Logo} alt="*" />
          <TextContainer>
            {ownerOptions.map((data, indexMenu) => (
              <Fragment key={`menu-${indexMenu.toString()}`}>
                {!data.children && (
                  <NavLink
                    to={data.url}
                    className={({ isActive: active }) => `nav-link${active ? 'active' : ''}`}
                  >
                    {data.name}
                  </NavLink>
                )}
                {data.children?.length && (
                  <>
                    <NavLink
                      to={data.url}
                      onMouseOver={handleClick}
                      className={({ isActive: active }) => `nav-link${active ? 'active' : ''}`}
                    >
                      {data.name}
                    </NavLink>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchor}
                      keepMounted
                      open={Boolean(anchor)}
                      onClose={handleClose}
                    >
                      {data.children.map((submenu, index) => (
                        <MenuItem key={`submenu-${index.toString()}`} onClick={handleClose}>
                          {submenu.name}
                        </MenuItem>
                      ))}
                    </Menu>
                    <ArrowDropDownIcon />
                  </>
                )}
              </Fragment>
            ))}
          </TextContainer>
          <ProfileLogout color="white" useOnlyArrow={false} />
        </Toolbar>
      </ColoredBar>
    );
  }

  return (
    <Wrapper>
      <ColoredBar>
        <Toolbar className="mobile" variant="dense">
          <ContainerImages>
            <LogoImage src={Logo} alt="*" />
            {mobile && (
              <button onClick={() => setOpen(!open)} type="button">
                <MenuMobile src={menuHamburguer} alt="menu" />
              </button>
            )}
          </ContainerImages>
          <WrapperNav open={open}>
            <TextContainer>
              {options.map((data, indexMenu) => (
                <Fragment key={`menu-${indexMenu.toString()}`}>
                  {!data.children && (
                    <NavLink
                      to={data.url}
                      className={({ isActive: active }) => `nav-link${active ? 'active' : ''}`}
                    >
                      {data.name}
                    </NavLink>
                  )}
                  {data.children?.length && (
                    <>
                      <NavLink
                        to={data.url}
                        onMouseOver={handleClick}
                        className={({ isActive: active }) => `nav-link${active ? 'active' : ''}`}
                      >
                        {data.name}
                      </NavLink>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchor}
                        keepMounted
                        open={Boolean(anchor)}
                        onClose={handleClose}
                      >
                        {data.children.map((submenu, index) => (
                          <MenuItem key={`submenu-${index.toString()}`} onClick={handleClose}>
                            {submenu.name}
                          </MenuItem>
                        ))}
                      </Menu>
                      <ArrowDropDownIcon />
                    </>
                  )}
                </Fragment>
              ))}
            </TextContainer>
            <ProfileLogout color="white" useOnlyArrow={false} />
          </WrapperNav>
        </Toolbar>
      </ColoredBar>
    </Wrapper>
  );
};

export default Header;
